import api from "../../../utilities/Interceptor";

const url = process.env.REACT_APP_API_KEY

interface Stop {
    nombre: string;
    hora_programada: string;
    hora_registro: string;
    hora_estimada: string;
}

interface StopsResponse {
    enRuta: boolean;
    paradas: Stop[];
}

export const getStops = async (idTrazo: number, idBitacora: number): Promise<StopsResponse> => {
    const res = await api.get<StopsResponse>(`${url}/maps/stops?id_trazo=${idTrazo}&id_bitacora=${idBitacora}`);
    return res.data;
}